import { render, staticRenderFns } from "./Varient.vue?vue&type=template&id=49ca1bd3&scoped=true&"
import script from "./Varient.vue?vue&type=script&lang=js&"
export * from "./Varient.vue?vue&type=script&lang=js&"
import style0 from "./Varient.vue?vue&type=style&index=0&id=49ca1bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ca1bd3",
  null
  
)

export default component.exports